import RefreshIcon from "@mui/icons-material/Refresh";
import { Box } from "@mui/material";
import React from "react";
import TaskIconButton from "../../../components/common/TaskIconButton";

/**
 * A refresh button component that triggers a refresh action
 *
 * @component
 * @param {Object} props - The component props
 * @param {Function} props.onRefresh - Callback function triggered when the refresh button is clicked
 * @param {Object} [props.sx] - Optional additional styling for the container box
 * @returns {React.ReactElement} A refresh button with icon
 *
 * @example
 * // Usage:
 * <RefreshButton onRefresh={() => fetchData()} />
 */
function RefreshButton({ onRefresh, sx = {} }) {
  return (
    <Box display="flex" justifyContent="flex-end" {...sx}>
      <TaskIconButton
        text="Refresh"
        color="inherit"
        icon={<RefreshIcon />}
        onClick={onRefresh}
        sx={{ px: 2, mx: 1, fontSize: "1rem" }}
      />
    </Box>
  );
}

export default RefreshButton;
